export default "__VITE_ASSET__JAMe4xE1__"